function toggleIngredients(button) {
  const hiddenItems = document.querySelectorAll('.hidden-ingredient');
  const isHidden = hiddenItems[0]?.classList.contains('hidden');

  hiddenItems.forEach(item => item.classList.toggle('hidden'));

  if (isHidden) {
    button.textContent = 'View less';
  } else {
    button.textContent = 'View more';
  }
}

// PRODUCT GALLERY -- START
$(document).ready(function(){
  $(".product-detail__images_").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: false,
    infinite: false,
    speed: 200,
    asNavFor: ".product-detail__thumbnails_",
    arrows: false,
    dots: false,
    draggable: true,
    focusOnSelect: false,
  });
  
  $(".product-detail__thumbnails_").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".product-detail__images_",
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    speed: 200,
    infinite: false,
    arrows: true,
    prevArrow:'<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><img src="https://cdn.shopify.com/s/files/1/0197/1244/2432/files/arrow-left.png?v=1745229521"></button>',
    nextArrow:'<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><img src="https://cdn.shopify.com/s/files/1/0197/1244/2432/files/arrow-left.png?v=1745229521"></button>',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      }
    ]
  });
}); 
// PRODUCT GALLERY -- END

// PRODUCT INGREDIENTS SLIDE -- START
$(document).ready(function(){
  $(".ingredient-slick").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    fade: false,
    infinite: false,
    arrows: false,
    dots: true,
    draggable: true,
    focusOnSelect: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1
        }
      }
    ]
  });
}); 
// PRODUCT INGREDIENTS SLIDE -- END

// cart drawer js -- begin

var $cartDrawer = $('#CartDrawer');
var $body = $('body');
jQuery(document).on("click",".js-cart-open",function (e) {
  e.preventDefault();
  e.stopPropagation();

  $cartDrawer.addClass('is-open');
  $body.addClass('cart-drawer-open');
});

jQuery(document).on("click",'.cartdrawer--close-button', function () {
  $cartDrawer.removeClass('is-open');
  $body.removeClass('cart-drawer-open');
});

// Close cart drawer if clicking outside of it
jQuery(document).on('click', function (e) {
  if (
    $cartDrawer.hasClass('is-open') &&
    !$(e.target).closest('#CartDrawer').length &&
    !$(e.target).hasClass('js-cart-open')
  ) {
    $cartDrawer.removeClass('is-open');
    $body.removeClass('cart-drawer-open');
  }
});

$(document).ready(function () {
  function updateQuantity($el, change) {
    var $wrapper = $el.closest('.quantity');
    var $input = $wrapper.find('.quantity__input');
    var line = $wrapper.data('line'); // Or use `data-key` if needed
    var newQty = parseInt($input.val()) + change;
    if (newQty < 1) newQty = 1;

    // Update input value
    $input.val(newQty);

    // Shopify AJAX update
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        line: line,   // or use `id: key` if you're using variant keys
        quantity: newQty
      },
      dataType: 'json',
      success: function (cart) {
        console.log('Cart updated:', cart);
        // Optionally refresh cart or show message
      },
      error: function (err) {
        console.error('Update failed:', err);
      }
    });
  }

  $('.cart_page .quantity__minus',function () {
    updateQuantity($(this), -1);
  });

  $('.cart_page .quantity__plus').click(function () {
    updateQuantity($(this), 1);
  });
});

/******************* CART DRAWER JS START *******************/
$(document).on('click','.cartdrawer .quantity__minus',function () {
  updatecartQuantity($(this), -1);
});

$(document).on('click','.cartdrawer .quantity__plus',function () {
  updatecartQuantity($(this), 1);
});

function updatecartQuantity($el, change) {
  var $wrapper = $el.closest('.quantity');
  var $input = $wrapper.find('.quantity__input');
  var line = $wrapper.data('line'); // Or use `data-key` if needed
  var newQty = parseInt($input.val()) + change;
  if (newQty < 1) newQty = 1;

  if(newQty>1){
    $el.parent().find('.quantity__remove').addClass('remove_hidden');
    $el.parent().find('.quantity__minus').removeClass('remove_hidden');
  }else{
    $el.parent().find('.quantity__remove').removeClass('remove_hidden');
    $el.parent().find('.quantity__minus').addClass('remove_hidden');
  }
  var mainprice = $el.parent().parent().attr('data-price');
  mainprice = (mainprice*newQty);
  mainprice = Shopify.formatMoney(mainprice);
  //console.log("hiii",$el.parent().parent().closest('.cart-summary__price').html());
  $el.parent().parent().parent('.cart_quantity_price').find('.cart-summary__price .theme-money').text(mainprice);
  // Update input value
  $input.val(newQty);

  // Shopify AJAX update
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: {
      line: line,   // or use `id: key` if you're using variant keys
      quantity: newQty
    },
    dataType: 'json',
    success: function (cart) {
      console.log('Cart updated:', cart);
      updateCartTotal();
      // Optionally refresh cart or show message
    },
    error: function (err) {
      console.error('Update failed:', err);
    }
  });
}
$(document).on('click','.cart-summary__product .quantity__remove',function () {
  var lineitemKey = jQuery(this).attr('data-lineid');
  removeProduct(lineitemKey);
});
jQuery(document).ready(function(){
  updateCartTotal();
});
function updateCartTotal(){
  $.getJSON('/cart.js', function(cart) {
    console.log("carrrr",cart);
    var totalCents = cart.total_price; // Shopify returns price in cents
    var totalDollars = (totalCents / 100).toFixed(2);
    jQuery('.cartdrawer--footer').find('.theme-money.subtotal_sale_price').text(`$${totalDollars}`);
    jQuery('.cartdrawer').find('.cart-count span').text('('+cart.item_count+' items)');
    if(cart.item_count>=1){
      if(jQuery('.header-cart').find('.header-cart__count').length>0){
        jQuery('.header-cart').find('.header-cart__count').text(cart.item_count);
      }else{
        jQuery('.header-cart').find('.js-cart-open').append('<span class="header-cart__count">'+cart.item_count+'</span>');
      }
      jQuery('.cartdrawer').removeClass('cart--empty');
      jQuery('.cartdrawer').find('.cartdrawer--empty').hide();
      jQuery('.cartdrawer').find('.cartdrawer--content').show();
      jQuery('.cartdrawer').find('.cc-cart-progress').show();
      jQuery('.cartdrawer').find('.cartdrawer--footer').show();
      jQuery('.cartdrawer').find('.essential-upsell-cross-sell-block').show();
      jQuery('.cartdrawer').find('.cart-count').show();
      jQuery('.cartdrawer').find('.cart-count span').text('('+cart.item_count+' items)');
    }else{
      jQuery('.cartdrawer').find('.cartdrawer--empty').show();
      jQuery('.cartdrawer').find('.cartdrawer--content').hide();
      jQuery('.cartdrawer').find('.cc-cart-progress').hide();
      jQuery('.cartdrawer').find('.essential-upsell-cross-sell-block').hide();
      jQuery('.cartdrawer').find('.cart-count span').text('');
      jQuery('.cartdrawer').find('.cartdrawer--footer').hide();
      jQuery('.cartdrawer').addClass('cart--empty');
      jQuery('.cartdrawer').find('.cart-count').hide();
      //jQuery('.header-cart').find('.header-cart__count').hide();
    }
    //progressbar js start here
    var goalObject = jQuery('.cartdrawer .cc-cart-progress');
    var goalAmount=goalObject.attr('data-goal-amount');
    var cart_goal_before_text = goalObject.attr('data-before-amount-text');
    var cart_goal_after_text = goalObject.attr('data-after-amount-text');
    var cart_goal_reached_text =  goalObject.attr('data-goal-reached-text');
    var icon_lock = goalObject.attr('data-svg-lock');
    var icon_unlock = goalObject.attr('data-svg-unlock');
    const cartTotal = cart.total_price / 100; // Shopify returns in cents
    const goal = goalAmount; // e.g., 50 for $50 free shipping goal
    const remaining = goal - cartTotal;
    const percentage = Math.min(Math.round((cartTotal / goal) * 100), 100);

    // Update progress bar width and text
    $('.cc-cart-progress-fill').css('width', percentage + '%');
    $('.cc-cart-progress-fill span').text(percentage + '%');

    // Toggle complete check icon
    if (percentage >= 100) {
      $('.cc-cart-progress-filled').show();
      $('.cc-cart-progressbar').addClass('progress-filled');
    } else {
      $('.cc-cart-progress-filled').hide();
      $('.cc-cart-progressbar').removeClass('progress-filled');
    }

    // Update goal message
    if (remaining > 0) {
      $('.cart__goal__message').html(`${cart_goal_before_text} <span class="cg-goal-amount text-money text-secondary" style="font-weight:bold">$${remaining.toFixed(2)}</span> ${cart_goal_after_text}`);
      // Optional: show locked icon, hide unlocked
      $('.svg-html').html(icon_lock);
    } else {
      $('.cart__goal__message').html(cart_goal_reached_text);
      $('.svg-html').html(icon_unlock);
    }
  });
}

function removeProduct(lineitemKey){
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: {
      id: lineitemKey,
      quantity: 0 // Set quantity to 0 to remove
    },
    dataType: 'json',
    success: function(cart) {
      prepareCartHtml();
    }
  });
}

// cart drawer js -- end

/****************** ADD TO CART QUICK JS START *******************/
$(".quick-buy__product-form,[name='add']").on("click",function(e){
  e.preventDefault();
  var variantID = jQuery(this).closest('form').find('[name=id] option:selected').val();
  //console.log("variantID",variantID);
  jQuery('.loading').show();
  $.ajax({
     type: 'POST',
     url: '/cart/add.js',
     data: {
      quantity: 1,
      id: variantID
     },
     dataType: 'json',
     success: function (data){
       if(data.quantity!=""){
         //console.log("jsondata"+data);
         //jQuery('.modal-cart').addClass('fade show');
         //jQuery('.modal-backdrop').addClass('fade show');
         //jQuery('.cart-value-modal').find('span').eq(1).text(data1.item_count);
         //jQuery('.header-cart__count').text(data1.item_count);
         jQuery('.loading').hide();
         //setTimeout(function(){
           prepareCartHtml(1);
         //},1000);
       }
     },
     error: function(xhr, status, error){
       jQuery('.loading').hide();
     }
   });
   return false;
});

function prepareCartHtml(openflag=''){
  if(openflag==1){
    var $cartDrawer = $('#CartDrawer');
    var $body = $('body');
    $cartDrawer.addClass('is-open');
    $body.addClass('cart-drawer-open');
  }

  ///products/on-my-tippies-in-almond-queen-midas-m?sections=ajax-product-card-bundle-almond
  
  $.ajax({
    type: 'GET',
    // url: '/cart.json',
    url:'/cart?sections=ajax-cart-drawer',
    //dataType: 'json',
    success: function (cartdata){
      console.log("cartdatata",cartdata);
      jQuery('.cartdrawer--inner').html(cartdata['ajax-cart-drawer']);
      updateCartTotal();
      return false;
      /*if(cartdata.item_count>=1){
        jQuery('.cartdrawer').removeClass('cart--empty');
        jQuery('.cartdrawer').find('.cartdrawer--empty').hide();
        jQuery('.cartdrawer').find('.cartdrawer--content').show();
        jQuery('.cartdrawer').find('.cc-cart-progress').show();
        jQuery('.cartdrawer').find('.cartdrawer--footer').show();
        jQuery('.cartdrawer').find('.essential-upsell-cross-sell-block').show();
        jQuery('.cartdrawer').find('.cart-count').show();
        jQuery('.cartdrawer').find('.cart-count span').text('('+cartdata.item_count+' items)');
        var cartHtml = '';
        cartdata = cartdata['items'];
        var indexp = 1;
        for(var r=0;r<cartdata.length;r++){
          var productHandle = cartdata[r].handle;
          var pimage = cartdata[r].image;
          var pimagealt = cartdata[r].featured_image.alt;
          var purl = cartdata[r].url;
          var ptitle = cartdata[r].title;
          var pquantity = cartdata[r].quantity;
          var lineItem = cartdata[r].key;
          var pprice = cartdata[r].price;
          var pcprice = cartdata[r].compare_price;
          pprice=Shopify.formatMoney(pprice);
          var $icon = '';
          var $removeIcon='remove_hidden';
          if(pquantity === 1) {
            $icon = 'remove_hidden';
            $removeIcon = '';
          }
  
          cartHtml +='<div class="cart-summary__product"><div class="cart-summary__product-image">';
          cartHtml +='<div class="rimage-outer-wrapper" style="max-width: 1500px; max-height: 1500px; --imgratio: 100.0%">';
          cartHtml +='<div class="rimage-wrapper " style="padding-top:100.0%">';
          cartHtml +='<img class="rimage__image fade-in lazyautosizes lazyloaded" data-widths="[180, 220, 300, 360, 460, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" srcset="'+pimage+'" data-aspectratio="1.0" data-sizes="auto" alt="'+pimagealt+'" data-srcset="'+pimage+'" style="">';
          cartHtml +='<noscript><img src="'+pimage+'" alt="'+pimagealt+'" class="rimage__image">';
          cartHtml +='</noscript></div></div></div>';
          cartHtml +='<div class="cart-summary__product__description">';
          cartHtml +='<div class="cart-summary__product-title"><a href="'+purl+'" title="'+ptitle+'">'+ptitle+'</a></div>';
          cartHtml +='<div class="cart-summary__product__variants"></div>';
          cartHtml +='<div class="cart_quantity_price"><div class="cart-summary__price"><span class="theme-money">'+pprice+'</span></div>';
          cartHtml +='<div class="quantity cart_quantity_picker" data-line="1" data-price="'+cartdata[r].price+'" data-cprice="'+pcprice+'"><div class="quantity__change flex">';
          
          cartHtml +='<a class="quantity__remove quantity-opt '+$removeIcon+'" data-lineid="'+lineItem+'" data-quantity="'+pquantity+'">';
          cartHtml +='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" class="icon icon-remove">';
          cartHtml +='<path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>';
          cartHtml +='<path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path></svg></a>';
          cartHtml +='<a class="btn--plain quantity__minus quantity-opt icon feather-icon '+$icon+'" href="javascript:void(0)" aria-label="Minus"><svg aria-hidden="true" focusable="false" role="presentation" class="icon feather-minus" viewBox="0 0 24 24"><path d="M5 12h14"></path></svg></a>';
          
          cartHtml +='<input class="quantity__number quantity__input" type="text" size="1" name="updates[]" value="'+pquantity+'" id="QuantityInput'+indexp+'" data-line="'+pquantity+'" data-initial-value="1" data-max="356" aria-label="Item quantity">';
          cartHtml +='<a class="btn--plain quantity__plus icon feather-icon " href="javascript:void(0)" aria-label="Plus"><svg aria-hidden="true" focusable="false" role="presentation" class="icon feather-plus" viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"></path></svg></a>';
          cartHtml +='</div></div></div></div></div>';
          indexp++;
        }
        if(cartHtml!=""){
          jQuery('.cartdrawer').find('.cartdrawer--inner').html(cartHtml);
        }
        updateCartTotal();
      }else{
        jQuery('.cartdrawer').find('.cartdrawer--empty').show();
        jQuery('.cartdrawer').find('.cartdrawer--content').hide();
        jQuery('.cartdrawer').find('.cc-cart-progress').hide();
        jQuery('.cartdrawer').find('.essential-upsell-cross-sell-block').hide();
        jQuery('.cartdrawer').find('.cart-count span').text('');
        jQuery('.cartdrawer').find('.cartdrawer--footer').hide();
        jQuery('.cartdrawer').addClass('cart--empty');
        jQuery('.cartdrawer').find('.cart-count').hide();
        jQuery('.header-cart').find('.header-cart__count').hide();
      }*/
    }
  });
}
/****************** ADD TO CART QUICK JS END *******************/

/* Counter == sections/business-needs.liquid -- START */

document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".business_needs_section");
  const speed = 200;
  let started = false;

  if (!section) return;

  const counters = section.querySelectorAll(".business_needs_number");
  if (counters.length === 0) return;

  function animateCounters() {
    counters.forEach(counter => {
      const target = +counter.getAttribute("data-target");
      const suffix = counter.getAttribute("data-suffix") || "";
      let count = 0;

      const updateCount = () => {
        const increment = target / speed;
        count += increment;

        if (count < target) {
          counter.innerText = Math.ceil(count).toLocaleString() + suffix;
          requestAnimationFrame(updateCount);
        } else {
          counter.innerText = target.toLocaleString() + suffix;
        }
      };

      updateCount();
    });
  }

  const observer = new IntersectionObserver(entries => {
    if (entries[0].isIntersecting && !started) {
      started = true;
      animateCounters();
    }
  }, {
    threshold: 0.4
  });

  observer.observe(section);
});


/* Counter == sections/business-needs.liquid -- END */

// MULTICOLUMN -- START
$(document).ready(function(){
  $(".multicolumn_grid").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    fade: false,
    infinite: false,
    arrows: false,
    dots: true,
    draggable: true,
    focusOnSelect: false,
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick"
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3.2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 2.2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}); 
// MULTICOLUMN -- END

// IMAGE TEXT SLIDER -- START
$(".image_text_slider").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  centerMode: false,
  focusOnSelect: true,
  speed: 400,
  infinite: true,
  arrows: true,
  prevArrow:'<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><img src="https://cdn.shopify.com/s/files/1/0197/1244/2432/files/arrow-left.png?v=1745229521"></button>',
  nextArrow:'<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><img src="https://cdn.shopify.com/s/files/1/0197/1244/2432/files/arrow-left.png?v=1745229521"></button>',
});
// IMAGE TEXT SLIDER -- END



// BUNDLE JS START 
  
jQuery(document).on("click",'.cart-heading .toggle-button-icon', function () {
  jQuery('.bundle-cart-side .bundle-cart-scroller , .bundle-cart-side .bundle-cart-footer').slideToggle()
});

document.addEventListener("DOMContentLoaded", function () {
  const wrappers = document.querySelectorAll(".product-button-wrapper");
  const cartWrapper = document.querySelector(".cart-product-item-wrapper");
  const progressBar = document.querySelector(".cart-progress");
  const cartMessage = document.querySelector(".cart-message");
  const offerBlocks = document.querySelectorAll(".cart-offer-block");
  const cartPriceElement = document.querySelector(".cart-price");
  const cartCountElement = document.querySelector(".cart_count");
  const checkoutBtn = document.querySelector(".bundle-cart-checkout-button button");

  // ------------------------------
  // LocalStorage Helper Functions
  // ------------------------------
  function saveCartToLocal() {
    const cartWrapper = document.querySelector(".cart-product-item-wrapper"); // ensure it's defined locally
    if (!cartWrapper) {
      console.warn("⚠️ cartWrapper not found. Skipping saveCartToLocal.");
      return;
    }

    const cartData = [];
    cartWrapper.querySelectorAll(".cart-product-item").forEach((item) => {
      const title = item.getAttribute("data-ptitle");
      const vid = item.getAttribute("data-vid");
      const count = parseInt(item.querySelector(".product-count")?.textContent || 0);
      cartData.push({ title, count, vid });
    });

    localStorage.setItem("bundleCart", JSON.stringify(cartData));
  }

  function loadCartFromLocal() {  
    const savedCart = JSON.parse(localStorage.getItem("bundleCart") || "[]");
    console.log("savedCart--->", savedCart)
    if (savedCart.length > 0) {
      savedCart.forEach(({ title, count }) => {
        const relatedWrapper = document.querySelector(`.product-button-wrapper[data-ptitle="${title}"]`);
        if (relatedWrapper) {
          const productImage = relatedWrapper.getAttribute("data-pimg");
          const input = relatedWrapper.querySelector(".quantity-value");
          const productVid = relatedWrapper.getAttribute("data-variant-id"); 

          relatedWrapper.classList.add("added");

          if (input) {
            input.value = count;
          } else {
            console.warn(`⚠️ Missing .quantity-value inside .product-button-wrapper for "${title}"`);
          }

          updateCartItem(title, productImage, count, productVid);
        }
      });
    }
    else{
    }
  }

  // ------------------------------
  // Core Cart Functions
  // ------------------------------
  function getTotalQty() {
    if (!cartWrapper) {
      console.warn("⚠️ cartWrapper not found — returning total = 0");
      return 0;
    }

    let total = 0;
    cartWrapper.querySelectorAll(".cart-product-item").forEach((item) => {
      const countEl = item.querySelector(".product-count");
      const count = countEl ? parseInt(countEl.textContent) || 0 : 0;
      total += count;
    });

    return total;
  }

  function getTotalPrice() {
    const wrapper = document.querySelector(".cart-product-item-wrapper");
    if (!wrapper) {
      console.warn("⚠️ cartWrapper not found — returning totalPrice = 0");
      return 0;
    }

    let totalPrice = 0;
    wrapper.querySelectorAll(".cart-product-item").forEach((item) => {
      const ptitle = item.getAttribute("data-ptitle");
      const relatedWrapper = document.querySelector(`.product-button-wrapper[data-ptitle="${ptitle}"]`);
      if (relatedWrapper) {
        const price = parseFloat(relatedWrapper.getAttribute("data-price")) || 0;
        const qtyEl = item.querySelector(".product-count");
        const qty = qtyEl ? parseInt(qtyEl.textContent) || 0 : 0;
        totalPrice += price * qty;
      }
    });

    return totalPrice;
  }

  // Updated Discount Logic
  function getDiscountPercent(totalQty) {
    // if (totalQty >= 6) return 20;
    // if (totalQty >= 5) return 10;
    // if (totalQty >= 2) return 5;
    if (totalQty == 1) return 20;
    if (totalQty == 2) return 30;
    if (totalQty >= 3) return 40;
    return 0;
  }

  function updateCartSummary() {
    const totalQty = getTotalQty();
    const totalPrice = getTotalPrice();
    const discountPercent = getDiscountPercent(totalQty);
    const discountAmount = (totalPrice * discountPercent) / 100;
    const finalPrice = totalPrice - discountAmount;

    if (cartPriceElement) {
      if (discountPercent > 0) {
        cartPriceElement.innerHTML = `
          <span class="cart-original-price" style="text-decoration: line-through; opacity: 0.6; margin-right: 8px;">
            ${Shopify.formatMoney(totalPrice)}
          </span>
          <span class="cart-discounted-price">
            ${Shopify.formatMoney(finalPrice)} 
            <small style="color: green;">(${discountPercent}% OFF)</small>
          </span>
        `;
      } else {
        cartPriceElement.textContent = Shopify.formatMoney(totalPrice);
      }
    }

    if (cartCountElement) {
      cartCountElement.textContent = totalQty;
      if(jQuery('.header-cart__count').length>0){
        jQuery('.header-cart__count').text(totalQty);
        if(totalQty==0){
          jQuery('.header-cart__count').hide();
        }else{
          jQuery('.header-cart__count').show();
        }
      }
    }

    // ✅ Checkout button enable/disable logic
    // const checkoutBtn = document.querySelector(".bundle-cart-checkout-button");
    // if (checkoutBtn) {
    //   if (totalQty >= 2) {
    //     checkoutBtn.removeAttribute("disabled");
    //     checkoutBtn.classList.add("active");
    //   } else {
    //     checkoutBtn.setAttribute("disabled", "true");
    //     checkoutBtn.classList.remove("active");
    //   }
    // }

    updateProgressBar();
    saveCartToLocal(); // Save after every update
  }

  // Updated Progress Bar Logic
  function updateProgressBar() {
    const progressBar = document.querySelector(".cart-progress");
    const cartMessage = document.querySelector(".cart-message");
    const offerBlocks = document.querySelectorAll(".cart-offer-block");

    if (!progressBar || !cartMessage || offerBlocks.length === 0) {
      console.warn("⚠️ Progress bar elements not found yet.");
      return;
    }

    const totalQty = getTotalQty();

    offerBlocks.forEach(block => block.classList.remove("active"));

    if (totalQty === 0) {
      progressBar.style.width = "0%";
      //cartMessage.innerHTML = `Add 2 products to <strong>unlock 5% off</strong>`;
      cartMessage.innerHTML = 'Start Fetching Savings — Add 1 Treat & Get 20% Off!';
    } 
    else if (totalQty >= 1 && totalQty < 2) {
      progressBar.style.width = "30%";
      offerBlocks[0]?.classList.add("active");
      //cartMessage.innerHTML = `Add 1 more product to <strong>unlock 5% off</strong>`;
      cartMessage.innerHTML = 'Savings are Stacking Up! Add 1 More Treat & Hit 30% Off!';
    } 
    else if (totalQty >= 2 && totalQty < 3) {
      progressBar.style.width = "60%";
      offerBlocks[0]?.classList.add("active");
      offerBlocks[1]?.classList.add("active");
      //cartMessage.innerHTML = `🎉 You’ve unlocked <strong>5% off!</strong> Add ${4 - totalQty} more to get <strong>10% off</strong>`;
      cartMessage.innerHTML = 'Your pup says don’t stop now — add one more for Black Friday’s 40% off!';
    } 
    else if (totalQty >= 3) {
      // progressBar.style.width = "100%";
      // offerBlocks[0]?.classList.add("active");
      // offerBlocks[1]?.classList.add("active");
      // //cartMessage.innerHTML = `🎉 You’ve unlocked <strong>10% off!</strong> Add ${6 - totalQty} more to get <strong>20% off</strong>`;
      // cartMessage.innerHTML = 'More treats? Your dog fully supports this decision — especially with 40% off!';

      progressBar.style.width = "100%";
      offerBlocks[0]?.classList.add("active");
      offerBlocks[1]?.classList.add("active");
      offerBlocks[2]?.classList.add("active");
      //cartMessage.innerHTML = `🔥 You’ve unlocked the maximum <strong>20% off!</strong>`;
      cartMessage.innerHTML = ' More treats? Your dog fully supports this decision — especially with 40% off!';
    } 
    else {
      progressBar.style.width = "100%";
      offerBlocks[0]?.classList.add("active");
      offerBlocks[1]?.classList.add("active");
      offerBlocks[2]?.classList.add("active");
      //cartMessage.innerHTML = `🔥 You’ve unlocked the maximum <strong>20% off!</strong>`;
      cartMessage.innerHTML = ' More treats? Your dog fully supports this decision — especially with 40% off!';
    }
  }

  function updateCartItem(productTitle, productImage, qty, productVid) {
    if (!cartWrapper) {
      console.warn("⚠️ cartWrapper not found — cannot update cart item yet.");
      return;
    }

    let existingItem = cartWrapper.querySelector(`[data-ptitle="${productTitle}"]`);

    if (qty > 0) {
      if (!existingItem) {
        const itemHTML = `
          <div class="cart-product-item" data-ptitle="${productTitle}" data-vid="${productVid}">
            <div class="image-box">
              <div class="product-count">${qty}</div>
              <div class="remove-product">
                <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g opacity="0.8">
                    <path d="M7.52429 0.53064L0.530055 7.53054" stroke="black" stroke-width="1.5"/>
                    <path d="M7.53003 7.5304L0.535792 0.530498" stroke="black" stroke-width="1.5"/>
                  </g>
                </svg>
              </div>
              <img src="${productImage}" alt="${productTitle}">
            </div>
            <p class="product-title">${productTitle}</p>
          </div>
        `;
        cartWrapper.insertAdjacentHTML("beforeend", itemHTML);
      } else {
        const countEl = existingItem.querySelector(".product-count");
        if (countEl) countEl.textContent = qty;
      }
    } else {
      if (existingItem) existingItem.remove();
    }

    updateCartSummary();
  }

  // ------------------------------
  // Product Card Events
  // ------------------------------
  wrappers.forEach((wrapper) => {
    const picker = wrapper.querySelector(".product-quantity-picker");
    const buttonText = wrapper.querySelector(".button-text");
    const bundleView = document.querySelector(".btn-bundle-view");
    const flashiconClose = document.querySelector(".flash-close-btn");

    // Skip this wrapper if picker is missing
    if (!picker) {
      // Still allow "Add to Bundle" button to work
      if (buttonText) {
        const productTitle = wrapper.getAttribute("data-ptitle");
        const productImage = wrapper.getAttribute("data-pimg");
        const productVid = wrapper.getAttribute("data-variant-id");
        buttonText.addEventListener("click", function () {
          if (!wrapper.classList.contains("added")) {
            wrapper.classList.add("added");
            let input = wrapper.querySelector(".quantity-value");
            if (input) input.value = 1;
            updateCartItem(productTitle, productImage, 1, productVid);
          }
        });
      }
      return; // Skip to next wrapper
    }

    const minusBtn = picker.querySelectorAll("button")[0];
    const plusBtn = picker.querySelectorAll("button")[1];
    const input = picker.querySelector(".quantity-value");

    const productTitle = wrapper.getAttribute("data-ptitle");
    const productImage = wrapper.getAttribute("data-pimg");
    const productVid = wrapper.getAttribute("data-variant-id");

    if (minusBtn) {
      minusBtn.addEventListener("click", () => {
        let currentValue = parseInt(input.value) || 0;
        if (currentValue > 1) {
          input.value = currentValue - 1;
        } else {
          input.value = 0;
          wrapper.classList.remove("added");
        }
        updateCartItem(productTitle, productImage, parseInt(input.value), productVid);
        showflashMessage(productTitle,0);
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener("click", () => {
        let currentValue = parseInt(input.value) || 0;
        input.value = currentValue + 1;
        wrapper.classList.add("added");
        updateCartItem(productTitle, productImage, parseInt(input.value), productVid);
        showflashMessage(productTitle,1);
      });
    }
    
    let flashTimeout;
    let flashMessage = document.querySelector('.bundle-flash-message');
    if (buttonText) {
      buttonText.addEventListener("click", function () {
        if (!wrapper.classList.contains("added")) {
          wrapper.classList.add("added");
          input.value = 1;
          updateCartItem(productTitle, productImage, 1, productVid);
          showflashMessage(productTitle,1);
        }
      });
    }
    

    function showflashMessage(product_title,flag){
      var flashProductTitle = document.querySelector('.flash-product-title');
      if (window.innerWidth < 901 && flashMessage) {
        if(product_title!="" && product_title!=undefined){
          if(flag==1){
            flashProductTitle.innerText = product_title+' added to your bundle';
          }else if(flag==0){
            flashProductTitle.innerText = product_title+' removed from your bundle';
          }
        }
        //flashMessage.style.display = "flex";
        flashMessage.classList.add("show_flash");
        clearTimeout(flashTimeout);
        // Set a new timeout to hide after 4 seconds
        flashTimeout = setTimeout(() => {
          //flashMessage.style.display = "none";
          flashMessage.classList.remove("show_flash");
        }, 6000);
      }
    }

    if (flashiconClose) {
      flashiconClose.addEventListener("click", function () {
        if(flashMessage!=null){
          //flashMessage.style.display="none";
          flashMessage.classList.remove("show_flash");
        }
      });
    }

    if(bundleView){
      bundleView.addEventListener("click", function () {
        const element = document.querySelector('.bundle-cart-side');
        const headerOffset = 100; // adjust as needed
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      });
    }
  });

  // ------------------------------
  // Remove Product
  // ------------------------------
  if (cartWrapper) {
    cartWrapper.addEventListener("click", (e) => {
      const removeBtn = e.target.closest(".remove-product");
      if (removeBtn) {
        const cartItem = removeBtn.closest(".cart-product-item");
        const ptitle = cartItem.getAttribute("data-ptitle");

        cartItem.remove();

        const relatedWrapper = document.querySelector(`.product-button-wrapper[data-ptitle="${ptitle}"]`);
        if (relatedWrapper) {
          relatedWrapper.classList.remove("added");
          const qtyInput = relatedWrapper.querySelector(".quantity-value");
          if (qtyInput) qtyInput.value = 0;
        }

        updateCartSummary();
      }
    });
  }

  // ------------------------------
  // Checkout Button
  // ------------------------------
  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", async () => {
      checkoutBtn.classList.add("btn--loading");

      const cartItems = [];
      document.querySelectorAll(".cart-product-item").forEach((item) => {
        const title = item.getAttribute("data-ptitle");
        const relatedWrapper = document.querySelector(`.product-button-wrapper[data-ptitle="${title}"]`);
        if (relatedWrapper) {
          const variantId = relatedWrapper.getAttribute("data-variant-id");
          const qty = parseInt(item.querySelector(".product-count").textContent) || 1;
          if (variantId && qty > 0) {
            cartItems.push({
              id: variantId,
              quantity: qty,
              properties: {
                "_bundleProduct": "Yes"
              }
            });
          }
        }
      });

      if (cartItems.length === 0) {
        checkoutBtn.classList.remove("btn--loading");
        alert("Your bundle is empty!");
        return;
      }

      try {
        await fetch("/cart/clear.js", { method: "POST" });
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: cartItems })
        });
        //localStorage.removeItem("bundleCart"); // clear local data on checkout
        window.location.href = "/checkout";
      } catch (error) {
        console.error("Checkout error:", error);
        checkoutBtn.classList.remove("btn--loading");
        alert("Something went wrong. Please try again.");
      }
    });
  }

  // ------------------------------
  // Initialize
  // ------------------------------
  loadCartFromLocal();
  updateCartSummary();
});


// ------------------------------
// Add to Bundle Button (Product Page)
// ------------------------------
document.addEventListener("click", function (e) {
  const addToBundleBtn = e.target.closest(".add_btn__bundle");
  if (!addToBundleBtn) return;

  // Find the nearest product wrapper (not global)
  const productSection = addToBundleBtn.closest(".product-button-wrapper");
  if (!productSection) {
    console.warn("⚠️ No product-button-wrapper found for clicked button.");
    return;
  }

  const wrapper = addToBundleBtn.closest(".qty_bundle_btn");
  const qtyInput = wrapper?.querySelector("#counter-value");
  const qty = parseInt(qtyInput?.value) || 1;

  // Get product info dynamically
  const title = productSection.getAttribute("data-ptitle") || "Untitled Product";
  const image = productSection.getAttribute("data-pimg") || "";
  const variantId = productSection.getAttribute("data-variant-id") || "";
  const price = parseFloat(productSection.getAttribute("data-price")) || 0;

  const productData = {
    title,
    vid: variantId,
    count: qty
  };

  console.log("🟢 productData:", productData);

  // --- Get or create the bundle array ---
  let existingBundle = [];
  try {
    existingBundle = JSON.parse(localStorage.getItem("bundleCart")) || [];
  } catch (e) {
    console.error("⚠️ Corrupted bundleCart data — resetting:", e);
    existingBundle = [];
  }

  // --- Check if the product already exists ---
  const existingIndex = existingBundle.findIndex(p => p.vid === productData.vid);

  if (existingIndex > -1) {
    // Already exists → update count
    existingBundle[existingIndex].count += qty;
  } else {
    // ✅ New product → add it
    existingBundle.push(productData);
  }

  // --- Save back to localStorage ---
  localStorage.setItem("bundleCart", JSON.stringify(existingBundle));

  console.log("✅ Updated bundleCart:", existingBundle);

  // --- Redirect to bundle page (enable when ready) ---
  window.location.href = "/pages/blackfridaybundlesale#bundle_chk";
});

// ------------------------------
// Add to Bundle Button (Home & collection Page)
// ------------------------------
document.addEventListener("DOMContentLoaded", function () {
  // Select all product wrappers
  const productWrappers = document.querySelectorAll(".product-button-wrapper__col"); // ✅ matches your HTML

  if (!productWrappers.length) {
    console.warn("⚠️ No product wrappers found on this page.");
    return;
  }

  productWrappers.forEach((wrapper) => {
    const addBtn = wrapper.querySelector(".add_btn__bundle_col");

    if (!addBtn) {
      console.warn("⚠️ No .add_btn__bundle_col found inside:", wrapper);
      return;
    }

    addBtn.addEventListener("click", function () {
      const productData = {
        title: wrapper.getAttribute("data-ptitle") || "Untitled Product",
        vid: wrapper.getAttribute("data-variant-id") || "",
        count: 1,
      };

      console.log("🟢 productData:", productData);

      // --- Get or create the bundle array ---
      let existingBundle = [];
      try {
        existingBundle = JSON.parse(localStorage.getItem("bundleCart")) || [];
      } catch (e) {
        console.error("⚠️ Corrupted bundleCart data — resetting:", e);
        existingBundle = [];
      }

      // --- Check if the product already exists ---
      const existingIndex = existingBundle.findIndex(p => p.vid === productData.vid);

      if (existingIndex > -1) {
        existingBundle[existingIndex].count += 1;
      } else {
        existingBundle.push(productData); // ✅ ensures new products are stored
      }

      // --- Save back to localStorage ---
      localStorage.setItem("bundleCart", JSON.stringify(existingBundle));

      console.log("✅ Saved bundleCart:", existingBundle);

      // --- Redirect to bundle page (uncomment when ready) ---
      window.location.href = "/pages/blackfridaybundlesale#bundle_chk";
    });
  });
});

if(jQuery('.temp-bundle').find('.hasmlcslick').length>0){
  $(".hasmlcslick").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 8,
    slidesToScroll: 1,
    prevArrow: '<button class="slick-prev slick-arrow"><svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.82843 11.8231H20V13.8231H7.82843L13.1924 19.187L11.7782 20.6012L4 12.8231L11.7782 5.04492L13.1924 6.45913L7.82843 11.8231Z" fill="black"/></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow"><svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.1716 11.8231L10.8076 6.45913L12.2218 5.04492L20 12.8231L12.2218 20.6012L10.8076 19.187L16.1716 13.8231H4V11.8231H16.1716Z" fill="black"/></svg></button>',
    responsive: [
      {
        breakpoint: 1099,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  });
}

if(jQuery('.temp-bundle').find('.banner__slider').length>0){
  $(".banner__slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    centerMode: false,
    focusOnSelect: true,
    speed: 400,
    infinite: true,
    arrows: false,
    prevArrow:'<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><img src="https://cdn.shopify.com/s/files/1/0197/1244/2432/files/arrow-left-line.png"></button>',
    nextArrow:'<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><img src="https://cdn.shopify.com/s/files/1/0197/1244/2432/files/arrow-right-line.png"></button>',
  });
}

//BLACK FRIDAY BUNDALE PAGE TAB WITH LOAD MORE DATA CODE START

jQuery(document).ready(function ($) {
  const $tabs = $('.collection-tab li');
  const $collections = jQuery('.main-bundle-builder-section').find('.collection_product_wrapp');

  // Hide all collections initially
  $collections.hide();

  // Activate first tab by default
  if ($tabs.length > 0 && $collections.length > 0) {
    $tabs.first().addClass('active');
    $collections.first().show();
  }

  // Tab click event
  $tabs.on('click', function () {
    const targetId = $(this).data('id');
    const $targetCollection = $('#' + targetId);

    // Remove active from all, then add to clicked tab
    $tabs.removeClass('active');
    $(this).addClass('active');
    if ($targetCollection.length) {
      let index = $collections.index($targetCollection);
      for(var f=0;f<=index;f++){
        $collections.eq(f).show();
      }
    }

    // Show selected collection
    if ($targetCollection.length) {
      //$targetCollection.show();

      // Auto scroll to section (with offset for sticky header)
      const offsetTop = $targetCollection.offset().top - 100;

      $('html, body').animate({
        scrollTop: offsetTop
      }, 500);
    }
  });
});

if(jQuery('.main-bundle-builder-section').find('.collection_product_wrapp').length>0){
  $(window).on("scroll", function () {
    let $current = $(".collection_product_wrapp:visible").last();  
    let bottomOfCurrent = $current.offset().top + $current.outerHeight();
    let scrollBottom = $(window).scrollTop() + $(window).height();
    if (scrollBottom >= bottomOfCurrent - 50) {
      let $next = $current.next(".collection_product_wrapp");
      if ($next.length && $next.css("display") === "none") {
        $next.css("display", "block");
      }
    }
  });
}

// Collection product mix not showing blank card code start
/*jQuery(document).ready(function ($) {
  if(jQuery('.main-bundle-builder-section').find('.collection-tab li').length>0){
    var mainObj = jQuery('.main-bundle-builder-section');
    const $tabs = mainObj.find('.collection-tab li');
    // -------------------------------
    // TAB CLICK
    // -------------------------------
    if($tabs!=null){
      $tabs.on('click', function () {
        const tab_slug = $(this).data('id');     // Example: soft-chewy
        const className = "pro__" + tab_slug;
        $tabs.removeClass('active');
        $(this).addClass('active');
        //$('.collection_product_wrapp').hide();

        // Show only wrappers containing matching product cards
        if(mainObj.find('.collection_product_wrapp').find('.'+className).length>0){
          let $allCards = mainObj.find('.collection_product_wrapp .bundle-product-card');
          let $matchedCards = $allCards.filter('.' + className);
          let firstIndex = $allCards.index($matchedCards.first());
          if (firstIndex >= 0) {
            for (let i = 0; i <= firstIndex; i++) {
                $allCards.eq(i).show();
            }
          }
          mainObj.find('.collection_product_wrapp').find('.'+className).show();
        }

        // Scroll to the first matching wrapper
        let $first = jQuery('.main-bundle-builder-section').find('.bundle-product-card.'+className).first();
        if ($first.length) {
          $('html, body').animate({
            scrollTop: $first.offset().top - 100
          }, 500);
        }
      });
    }
  }

  // -------------------------------
  // LOAD MORE ON SCROLL
  // -------------------------------
  var ROW_SIZE = 4;
  $(window).on("scroll", function () {
    if(jQuery('.main-bundle-builder-section').find(".collection_product_wrapp").length>0){
      let $currentWrap = jQuery('.main-bundle-builder-section').find(".collection_product_wrapp:visible").last();
      if (!$currentWrap.length) return;

      let bottom = $currentWrap.offset().top + $currentWrap.outerHeight();
      let scrollBottom = $(window).scrollTop() + $(window).height();

      if (scrollBottom < bottom - 50) return;

      let $cards = $currentWrap.find('.bundle-product-card');
      let visibleCount = $cards.filter(':visible').length;
      let nextRow = $cards.slice(visibleCount, visibleCount + ROW_SIZE);


      // If next row exists → show it
      if (nextRow.length > 0) {
        nextRow.show();
        return;
      }
      // ------------------------------------------
      // Current wrapper finished → move to next
      // ------------------------------------------
      let $nextWrap = $currentWrap.next('.collection_product_wrapp');
      if ($nextWrap.length && $nextWrap.css("display") === "none") {
        $nextWrap.show();
        $nextWrap.find('.bundle-product-card')
                .slice(0, ROW_SIZE)
                .show();
      }
    }
  });
});*/
// Collection product mix not showing blank card code end

//BLACK FRIDAY BUNDALE PAGE TAB WITH LOAD MORE DATA CODE END 
